/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {QuestionnairesState} from './questionnaires.reducer';

// Selector functions
const questionnaireSelector =
  createFeatureSelector<QuestionnairesState>('ss-cord.questionnaires');

// Get Questionnaires List
export const questionnairesList = createSelector(
  questionnaireSelector,
  (state: QuestionnairesState) => state.questionnairesList
);

export const fetchAddSurveyDetails = createSelector(questionnaireSelector, (state) => state.createSurvey.survey)

export const fetchMyQuestionnairesList = createSelector(questionnaireSelector, state => state.myQuestionnairesList)

export const fetchQuestionnairesDetails = createSelector(questionnaireSelector, (state) => state.myQuestionnairesDetails)

export const fetchReviewSurveyDetails = createSelector(questionnaireSelector, state => state.surveyReview)

export const fetchEditSurveySummaryDetails = createSelector(questionnaireSelector, (state) => state.editSurvey.summaryDetails)

export const fetchEditSurveyQuestionnairesDetails = createSelector(questionnaireSelector, (state) => state.editSurvey.surveyDetails)


export const FetchDetailsForDuplicateSurveyScheduleDetails = createSelector(questionnaireSelector, state => state.surveyDuplicate.schedule)

export const FetchDetailsForDuplicateSurveyFormDetails = createSelector(questionnaireSelector, state => state.surveyDuplicate.surveyForm)

export const FetchDetailsForDuplicateSurveySendToDetails = createSelector(questionnaireSelector, state => state.surveyDuplicate.sendTo)

export const FetchManageSurveyList = createSelector(questionnaireSelector, state => state.manageSurveyList)


export const SessionDetailsForCreateSurvey = createSelector(questionnaireSelector, state => state.createSurvey.session)

export const FetchScheduleAccordingToList = createSelector(questionnaireSelector, state => state.createSurvey.scheduleAccordingToDetails)

export const FetchRolesListForFilters = createSelector(questionnaireSelector, state => state.sendToFilters.roles)


export const FetchGenderListForFilters = createSelector(questionnaireSelector, state => state.sendToFilters.gender)

export const FetchClinicListForFilters = createSelector(questionnaireSelector, state => state.sendToFilters.clinics)

export const FetchGroupStatusListForFilters = createSelector(questionnaireSelector, state => state.sendToFilters.groupStatus)

export const FetchGroupListForFilters = createSelector(questionnaireSelector, state => state.sendToFilters.groups)


export const FetchSurveyDetails = createSelector(questionnaireSelector, state => state.surveyDetails)

export const fetchSurveyResponseForReviewForAdmins = createSelector(questionnaireSelector, state => state.surveyResponseReview)

export const pendingSurveyCount = createSelector(questionnaireSelector, state => state.pendingSurveyCount)